import React from 'react';
import './HomeBanner.css';
import banner from './banner.jpg';
import logo from './logo.png';

const HomeBanner = () => {
    return (
        <div>
            {/* Banner Start */}
            <div className="banner" style={{position: 'relative'}}>
                {/* <h2 style={{ position: 'absolute', left: '45%', top: '40%' }} className="">Sports Mania</h2> */}
                <div className="logo" style={{ position: 'absolute', left: '35%', top: '25%' }}><img src={logo} className="img-fluid" style={{ width: '70%' }} alt=""/></div>
                <img src={banner} alt="" style={{width: '100%', height: '70%'}}/>
            </div>
            {/* Banner End */}
        </div>
    );
};

export default HomeBanner;